import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import MissionBanner from "@/components/MissionBanner";
import { toast } from "sonner";

const NAVY = "#132a63";
const GREEN = "#16a34a";
const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmt = (iso) => { try { return new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" }); } catch { return iso; } };

export default function PortalAfiliado() {
  const { logout } = useAuth();
  const [d, setD] = useState(null);
  const [handle, setHandle] = useState("");
  const [lb, setLb] = useState(null);
  useEffect(() => {
    apiClient.get("/afiliados/me").then(({ data }) => setD(data)).catch(() => toast.error("Error al cargar tu panel"));
    apiClient.get("/afiliados/leaderboard").then(({ data }) => setLb(data)).catch(() => {});
  }, []);

  const copy = () => {
    const link = d.tracking_link;
    try {
      const el = document.querySelector('[data-testid="af-tracking-link"]');
      if (el) { el.focus(); el.select(); }
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(link);
      else document.execCommand("copy");
    } catch { /* noop */ }
    toast.success("¡Link copiado! Compártelo en tus redes.");
  };
  const copyText = (txt) => {
    try {
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(txt);
    } catch { /* noop */ }
    toast.success("Texto copiado ✍️");
  };
  const BANNERS = [
    { src: "/socios/kit/banner_familia.png", name: "Protege a tu familia", tag: "Historia / Reel" },
    { src: "/socios/kit/banner_asistencia.png", name: "Asistencia 24/7", tag: "Historia / Reel" },
    { src: "/socios/kit/banner_marca.png", name: "Mi Ángel Asís", tag: "Post cuadrado" },
  ];
  const downloadCustom = (src, fname) => {
    const who = (handle || d?.nombre || "").trim();
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const W = img.naturalWidth, H = img.naturalHeight;
      const foot = Math.round(W * 0.17);
      const c = document.createElement("canvas");
      c.width = W; c.height = H + foot;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, W, H);
      ctx.fillStyle = NAVY; ctx.fillRect(0, H, W, foot);
      ctx.fillStyle = GREEN; ctx.fillRect(0, H, W, Math.round(foot * 0.06));
      ctx.textAlign = "center";
      ctx.fillStyle = "#ffffff";
      ctx.font = `800 ${Math.round(W * 0.058)}px Poppins, Arial, sans-serif`;
      ctx.fillText(who ? `Recomendado por ${who}` : "Únete y protégete", W / 2, H + foot * 0.44);
      ctx.fillStyle = "#8CE313";
      ctx.font = `700 ${Math.round(W * 0.042)}px Poppins, Arial, sans-serif`;
      ctx.fillText(`angelasis.com  ·  Código: ${d?.codigo || ""}`, W / 2, H + foot * 0.80);
      c.toBlob((blob) => {
        if (!blob) { toast.error("No se pudo generar el banner"); return; }
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url; a.download = fname; a.click();
        URL.revokeObjectURL(url);
        toast.success("¡Banner personalizado descargado! 🎉");
      }, "image/png");
    };
    img.onerror = () => toast.error("No se pudo cargar el banner");
    img.src = src;
  };
  const comLabel = d?.commission_type === "percent" ? `${d?.commission_value}% por venta` : `${money(d?.commission_value)} por venta`;

  const link = d?.tracking_link || "";
  const TEMPLATES = [
    { titulo: "Para TikTok / Reels", texto: `¿Sabías que puedes proteger a toda tu familia desde $80 al mes? 🙌\n\nMi Ángel Asís te da asistencia médica, ambulancia, grúa y apoyo legal 24/7. Yo ya la tengo y me da tranquilidad total.\n\n👉 Actívala aquí: ${link}` },
    { titulo: "Para WhatsApp / Estados", texto: `Te recomiendo Mi Ángel Asís 💚 Protección y asistencia para tu familia (médica, grúa, ambulancia, legal) desde $80 al mes. Regístrate con mi link: ${link}` },
    { titulo: "Para Facebook / Instagram", texto: `Nada más importante que tu familia. 💙 Con Mi Ángel Asís tienes asistencia médica, psicológica, legal y vial 24/7 desde solo $80 al mes.\n\nActiva tu protección hoy 👉 ${link}` },
  ];

  if (!d) return <div style={{ ...wrap, color: "white" }}><i className="fas fa-spinner fa-spin" style={{ fontSize: 34 }} /></div>;

  return (
    <div style={wrap}>
      <Helmet><title>Mi Panel de Socio — Mi Ángel Asís</title></Helmet>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ color: "white", fontSize: 22, fontWeight: 800 }}>Hola, {d.nombre} 👋</div>
            <div style={{ color: "#cbd5e1", fontSize: 14 }}>{d.tipo === "influencer" ? "Influencer" : "Afiliado"} · Comisión: <strong style={{ color: GREEN }}>{comLabel}</strong></div>
          </div>
          <button onClick={logout} data-testid="socios-logout" style={{ background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", padding: "9px 16px", borderRadius: 999, fontWeight: 700, cursor: "pointer" }}>Salir</button>
        </header>

        <MissionBanner variant="dark" seguidores={d.seguidores} ventasActuales={d.ventas_total} />

        {/* CTA datos de pago */}
        <div style={panel} data-testid="af-pagos-cta">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 800, color: NAVY }}>💳 Datos para recibir tus comisiones</div>
              <div style={{ fontSize: 13, color: "#6b7280" }}>Da de alta tu CLABE/tarjeta y tus datos fiscales para que podamos depositarte.</div>
            </div>
            <a href="/socios/pagos" data-testid="af-go-pagos" style={{ background: NAVY, color: "white", textDecoration: "none", padding: "11px 20px", borderRadius: 999, fontWeight: 800, whiteSpace: "nowrap" }}>Configurar pagos →</a>
          </div>
        </div>


        {/* Ilustraciones testimoniales (pop-art) */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 14, marginBottom: 18 }} data-testid="socios-ilustraciones">
          {[
            { img: "/socios/socio_hombre.png", cap: "«Gracias Ángel, ya tengo la universidad de mi hijo.»" },
            { img: "/socios/socia_mujer.png", cap: "«Gracias Ángel, ya puedo empezar mi negocio.»" },
          ].map((t, i) => (
            <div key={i} style={{ background: "white", borderRadius: 16, overflow: "hidden", boxShadow: "0 2px 10px rgba(0,0,0,0.12)" }}>
              <img src={t.img} alt="Socio feliz recibiendo comisiones" loading="lazy"
                style={{ width: "100%", height: 210, objectFit: "cover", display: "block" }} />
              <div style={{ padding: "12px 14px", fontWeight: 700, color: NAVY, fontSize: 14, textAlign: "center", fontStyle: "italic" }}>{t.cap}</div>
            </div>
          ))}
        </div>

        {/* Tracking link */}
        <div style={panel}>
          <div style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginBottom: 8 }}>🔗 Tu link único de referido</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <input readOnly value={d.tracking_link} data-testid="af-tracking-link"
              style={{ flex: 1, minWidth: 220, padding: "11px 13px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 13, background: "#F3F7FF" }} />
            <button onClick={copy} data-testid="af-copy-link" style={{ background: GREEN, color: "white", border: "none", padding: "11px 20px", borderRadius: 10, fontWeight: 800, cursor: "pointer" }}>Copiar</button>
          </div>
          <p style={{ fontSize: 12, color: "#6b7280", marginTop: 8 }}>Comparte este link. Cada venta que se genere con él te da comisión automáticamente.</p>
        </div>

        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12, marginBottom: 16 }}>
          <Card label="Visitas" value={d.visitas} testid="af-stat-visitas" />
          <Card label="Registros" value={d.leads} testid="af-stat-leads" />
          <Card label="Ventas" value={d.ventas_total} color={GREEN} testid="af-stat-ventas" />
          <Card label="Comisión generada" value={money(d.comision_generada)} testid="af-stat-generada" />
          <Card label="Saldo por cobrar" value={money(d.saldo_pendiente)} color="#b45309" testid="af-stat-saldo" />
          <Card label="Ya pagado" value={money(d.comision_pagada)} color={GREEN} testid="af-stat-pagado" />
        </div>

        {/* Sales */}
        <div style={panel}>
          <div style={{ fontSize: 15, fontWeight: 800, color: NAVY, marginBottom: 10 }}>Tus ventas</div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }} data-testid="af-ventas-table">
              <thead><tr style={{ textAlign: "left", color: "#6b7280" }}><th style={th}>Folio</th><th style={th}>Plan</th><th style={th}>Monto</th><th style={th}>Fecha</th><th style={th}>Estatus</th></tr></thead>
              <tbody>
                {d.ventas.map((v, i) => (
                  <tr key={i} style={{ borderTop: "1px solid #f1f5f9" }}>
                    <td style={td}><strong>{v.folio}</strong></td><td style={td}>{v.plan}</td><td style={td}>{money(v.precio)}</td>
                    <td style={td}>{fmt(v.fecha)}</td>
                    <td style={td}><span style={{ fontWeight: 700, color: v.estatus === "active" ? GREEN : "#E84C5E", fontSize: 12 }}>{v.estatus}</span></td>
                  </tr>
                ))}
                {!d.ventas.length && <tr><td colSpan={5} style={td}>Aún no tienes ventas. ¡Comparte tu link para empezar! 🚀</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Leaderboard (visible con 20+ socios) */}
        {lb?.enabled && (
          <div style={panel} data-testid="socios-leaderboard">
            <div style={{ fontSize: 15, fontWeight: 800, color: NAVY, marginBottom: 10 }}>🏆 Top socios del mes</div>
            {lb.top.map((r) => (
              <div key={r.pos} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px", borderRadius: 8, marginBottom: 4, background: r.es_tuyo ? "#EAF6ED" : "transparent" }}>
                <span style={{ fontWeight: r.es_tuyo ? 800 : 600, color: NAVY }}>
                  <span style={{ display: "inline-block", width: 26 }}>{r.pos <= 3 ? ["🥇", "🥈", "🥉"][r.pos - 1] : `${r.pos}.`}</span>
                  {r.nombre}{r.es_tuyo ? " (tú)" : ""}
                </span>
                <strong style={{ color: GREEN }}>{r.ventas} ventas</strong>
              </div>
            ))}
          </div>
        )}

        {/* Kit de materiales */}
        <div style={panel} data-testid="socios-kit">
          <div style={{ fontSize: 15, fontWeight: 800, color: NAVY, marginBottom: 4 }}>🎨 Kit de materiales</div>
          <p style={{ fontSize: 13, color: "#6b7280", marginTop: 0, marginBottom: 10 }}>Descarga banners listos y copia los textos (¡ya llevan tu link!).</p>
          <div style={{ background: "#F3F7FF", borderRadius: 10, padding: "10px 12px", marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: NAVY }}>✨ Personaliza tus banners</label>
            <input value={handle} onChange={(e) => setHandle(e.target.value)} placeholder={d.nombre || "@tu_usuario"} data-testid="kit-handle-input"
              style={{ width: "100%", marginTop: 6, padding: "9px 11px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 14, boxSizing: "border-box" }} />
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>Se agregará "Recomendado por {handle || d.nombre}" y tu código al pie del banner.</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12, marginBottom: 16 }}>
            {BANNERS.map((b, i) => (
              <div key={i} style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden", background: "#fff" }}>
                <img src={b.src} alt={b.name} loading="lazy" style={{ width: "100%", height: 160, objectFit: "cover", display: "block" }} />
                <div style={{ padding: "8px 10px" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: NAVY }}>{b.name}</div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>{b.tag}</div>
                  <button onClick={() => downloadCustom(b.src, `miangelasis_${i}.png`)} data-testid={`kit-download-${i}`}
                    style={{ display: "block", width: "100%", textAlign: "center", background: NAVY, color: "white", border: "none", cursor: "pointer", padding: "8px 0", borderRadius: 8, fontWeight: 700, fontSize: 13 }}>
                    Descargar personalizado
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginBottom: 8 }}>Textos listos para publicar</div>
          {TEMPLATES.map((t, i) => (
            <div key={i} style={{ background: "#F3F7FF", borderRadius: 10, padding: 12, marginBottom: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, gap: 8 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: GREEN }}>{t.titulo}</span>
                <div style={{ display: "flex", gap: 6 }}>
                  <a href={`https://wa.me/?text=${encodeURIComponent(t.texto)}`} target="_blank" rel="noreferrer" data-testid={`kit-wa-share-${i}`}
                    style={{ background: "#25D366", color: "white", textDecoration: "none", padding: "6px 12px", borderRadius: 8, fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" }}>
                    <i className="fab fa-whatsapp" /> WhatsApp
                  </a>
                  <button onClick={() => copyText(t.texto)} data-testid={`kit-copy-text-${i}`}
                    style={{ background: NAVY, color: "white", border: "none", padding: "6px 14px", borderRadius: 8, fontWeight: 700, cursor: "pointer", fontSize: 12 }}>Copiar</button>
                </div>
              </div>
              <div style={{ fontSize: 13, color: "#374151", whiteSpace: "pre-line", lineHeight: 1.5 }}>{t.texto}</div>
            </div>
          ))}
        </div>

        {/* Payouts */}
        <div style={panel}>
          <div style={{ fontSize: 15, fontWeight: 800, color: NAVY, marginBottom: 10 }}>Historial de pagos</div>
          {d.payouts.length ? d.payouts.map((p, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f5f9", fontSize: 14 }}>
              <span>{fmt(p.fecha)} · {p.metodo}{p.referencia ? ` · ${p.referencia}` : ""}</span>
              <strong style={{ color: GREEN }}>{money(p.monto)}</strong>
            </div>
          )) : <p style={{ color: "#6b7280", fontSize: 14 }}>Todavía no se te ha realizado ningún pago.</p>}
        </div>

        <div style={{ ...panel, background: "#EAF6ED" }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: NAVY, marginBottom: 6 }}>💡 Tips para vender más</div>
          <ul style={{ margin: 0, paddingLeft: 18, color: "#374151", fontSize: 13, lineHeight: 1.7 }}>
            <li>Comparte historias reales de por qué la asistencia importa (grúa, ambulancia, apoyo legal).</li>
            <li>Usa tu link en la bio de TikTok/Instagram y en cada video.</li>
            <li>Publica el precio y el beneficio principal en los primeros 3 segundos.</li>
            <li>No hagas promesas engañosas: describe la protección tal cual es. 🙏</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, color, testid }) {
  return (
    <div style={{ background: "white", borderRadius: 14, padding: 16, boxShadow: "0 2px 10px rgba(0,0,0,0.06)" }}>
      <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: color || NAVY }} data-testid={testid}>{value}</div>
    </div>
  );
}

const wrap = { minHeight: "100vh", background: NAVY, padding: "28px 18px", fontFamily: "'Poppins',system-ui,sans-serif", display: "block", alignItems: "center", justifyContent: "center" };
const panel = { background: "white", borderRadius: 16, padding: 18, marginBottom: 16, boxShadow: "0 2px 10px rgba(0,0,0,0.06)" };
const th = { padding: "8px 10px", fontWeight: 600, fontSize: 12 };
const td = { padding: "8px 10px" };
